function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHome = function SvgHome(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.844,
    height: 16.7
  }, props), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 95"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Regular 95"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M359.25 1303.25v1.867a.934.934 0 0 0 .933.933h3.733a.934.934 0 0 0 .933-.933v-1.867",
    "data-name": "Shape 696",
    style: {
      fill: "none",
      stroke: "#333",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".7px"
    },
    transform: "translate(-350.367 -1290.633)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m365.583 1299.4-4.043-3.64a.934.934 0 0 0-1.248 0l-4.043 3.64",
    "data-name": "Shape 697",
    style: {
      fill: "none",
      stroke: "#333",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".7px"
    },
    transform: "translate(-349.233 -1288.635)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.75 1298.927v-2.427",
    "data-name": "Shape 698",
    style: {
      fill: "none",
      stroke: "#333",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".7px"
    },
    transform: "translate(-354.333 -1289.035)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.75 1287.283a.533.533 0 0 0-.533-.533h-14.934a.533.533 0 0 0-.533.533v14.933a.533.533 0 0 0 .533.533h2.133a.534.534 0 0 0 .533-.533v-12.266h12.267a.533.533 0 0 0 .533-.533z",
    "data-name": "Shape 699",
    style: {
      fill: "none",
      stroke: "#333",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".7px"
    },
    transform: "translate(-348.4 -1286.4)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.75 1297.25h.933",
    "data-name": "Shape 700",
    style: {
      fill: "none",
      stroke: "#333",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".7px"
    },
    transform: "translate(-349.533 -1289.433)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.75 1303.25h.933",
    "data-name": "Shape 701",
    style: {
      fill: "none",
      stroke: "#333",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".7px"
    },
    transform: "translate(-349.533 -1291.167)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.25 1290.683v-.933",
    "data-name": "Shape 702",
    style: {
      fill: "none",
      stroke: "#333",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".7px"
    },
    transform: "translate(-351.433 -1287.533)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.25 1290.683v-.933",
    "data-name": "Shape 703",
    style: {
      fill: "none",
      stroke: "#333",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".7px"
    },
    transform: "translate(-353.167 -1287.533)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.75 1289.55h2.8v-2.8",
    "data-name": "Shape 704",
    style: {
      fill: "none",
      stroke: "#333",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".7px"
    },
    transform: "translate(-348.4 -1286.4)"
  }))));
};
export { SvgHome as ReactComponent };
export default "data:image/svg+xml;base64,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";